<template>

	<el-card class="box-card">
		<div slot="header" class="clearfix">
			<span style="background:#f7fafa ;" class="dd">系统回复</span>
			<el-form ref="form" :model="shu">
				<el-form-item label="关注欢迎关键字:" label-width="210px" style="	margin-top: 20px;">
					<el-input placeholder="当关注公众号时.触发该关键词;" v-model="shu.guanzhu" class="input-with-select" />
				</el-form-item>
				<el-form-item label="默认回复关键字:" label-width="210px">
					<el-input placeholder="当系统不知道该如何回复粉丝的消息时,触发该关键词" v-model="shu.moren" class="input-with-select" />
				</el-form-item>
				<el-form-item>
					<Tijiao type="danger" @click="Tijiao" wenzi="提交" size="medium" style="margin-left:210px;" />
				</el-form-item>
			</el-form>
		</div>
	</el-card>

</template>

<script>
	let that;
	export default {
		data() {
			return {
				shu: {}
			}
		},
		created() {
			that = this;
			this.CSH();
		},
		methods: {
			CSH() {
				this.$post('k=huifu&c=xitong', function(s) {
					that.shu = s.shu;
				});
			},
			Tijiao() {
				this.$post('k=huifu&c=xitongxiugai',that.shu, function(s) {
					that.$xiaoxi(s.shu);
					if (s.shi == 1) {
						that.CSH();
					}
				});
			}
		}
	}
</script>

<style>

</style>
